import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { setPTZFailed, setPTZSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* setPTZ(action) {
  try {
    const { id, values, withDelay = false } = action.payload;
    const url = `${BACKEND_URL}/camera/set-ptz/${id}`;
    yield delay(500);
    const dataResponse = yield makeRequest(url, values, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(setPTZSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(setPTZFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(setPTZFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
